var BTFreBought = {
	selectors: {
		selectedClass: 'selected',
		checkbox: '.pg__fre-check',
		variantSelect: '.variant-id',
		pItem: '.pg',
		frebItem: '.freb__item',
		frebItemImage: '.freb__item__image',
		frebMainImage: '.freb__main-image',
		frebMainImageWrap: '.freb__main-image-wrap',
		totalPrice: '.freb__total-price',
		addBtn: '.freb__add-btn',
		qtyBox: '.qty-box__input--fre',
		wrap: '.fre-bought'
	},

	updateTotalBox: function(wrap) {
		var price = 0;
		var comparePrice = 0;
		var ins = this;
		var count = 0;
		wrap.find(this.selectors.pItem + '.' + this.selectors.selectedClass).each(function() {
			var option = $(this).find(ins.selectors.variantSelect + ' option:selected');
			var qty = parseInt($(this).find(ins.selectors.qtyBox).first().val());
			if(option.data('available')) {
				price += parseInt(option.data('price')) * qty;
				comparePrice += parseInt(option.data('compare-price')) * qty;
				count++;
			}
		});
		wrap.find(this.selectors.totalPrice).html(this.getTotalPriceHtml(price, comparePrice));
		if(count > 0) {
			wrap.find(this.selectors.addBtn).removeAttr('disabled');
		} else {
			wrap.find(this.selectors.addBtn).attr('disabled', 'disabled');
		}
		BT.convertCurrencySilence(wrap.find('span.money'));
	},

	getTotalPriceHtml: function(price, comparePrice) {
    var priceHtml = '';
    if(comparePrice > price) {
    	priceHtml += '<span class="product-price__price product-price__price--freb">' + BT.getPriceHtml(price) + '</span>';
      priceHtml += '<s class="product-price__price product-price__price--freb">' + BT.getPriceHtml(comparePrice) + '</s>';      
    } else {
      priceHtml += '<span class="product-price__price product-price__price--freb">' + BT.getPriceHtml(price) + '</span>';
    }
    return priceHtml;
  },

  init: function() {
		var ins = this, selector = this.selectors;
		$(selector.checkbox).unbind('click');
		$(selector.checkbox).on('click', function(e){
			e.preventDefault();
			$(this).closest(ins.selectors.pItem).toggleClass(ins.selectors.selectedClass);
			ins.updateTotalBox($(this).closest(ins.selectors.wrap));
		});
		$(selector.variantSelect).unbind('change');
		$(selector.variantSelect).on('change', function(){
			var variantId = $(this).val();
			var option = $(this).children('option[value="' + variantId + '"]');
			var pg = $(this).closest(ins.selectors.pItem);
			if(!option.data('available')) {
				pg.find(ins.selectors.checkbox).attr('disabled', 'disabled');
			} else {
				pg.find(ins.selectors.checkbox).removeAttr('disabled');
			}
			ins.updateTotalBox(pg.closest(ins.selectors.wrap));
		});
		$(selector.addBtn).unbind('click');
		$(selector.addBtn).on('click', function() {
			var wrap = $(this).closest(ins.selectors.wrap), params = [];
			var selectedItems = wrap.find(ins.selectors.pItem + '.' + ins.selectors.selectedClass);
			selectedItems.each(function() {
				var option = $(this).find(ins.selectors.variantSelect + ' option:selected');
				var qty = $(this).find(ins.selectors.qtyBox).first().val();
				if(option.data('available')) {
					var variantId = option.attr('value');
					params.push({id: variantId, quantity: qty});
				}
			});
			BT.showLoadingFull();

			BT.callAjax(theme.cartAddUrl, 'post', {items: params}, 'json', function(){
  			document.location.href = theme.cartUrl;
  		});
		});
		$(document).on('change', this.selectors.qtyBox, function() {
			ins.updateTotalBox($(this).closest(ins.selectors.wrap));
		});
		var frebMainImage = $(selector.frebMainImage);
		var frebMainImageWrap = $(selector.frebMainImageWrap);
		$(document).on('mouseenter', this.selectors.frebItem, function() {
			frebMainImage.hide();
			var frebItemImage = $(this).find(selector.frebItemImage);
			var imageId = frebItemImage.attr('data-image-id');
			var currentImage = frebMainImageWrap.find(selector.frebItemImage + '[data-image-id="' + imageId + '"]');
			if(currentImage.length > 0) {
				currentImage.show();
			} else {
				var newDiv = $('<div class="img-container ' + selector.frebItemImage.replace('.','') + ' loading" style="' + frebItemImage.attr('style') + '" data-image-id="' + frebItemImage.attr('data-image-id') + '"></div>');
				newDiv.html(frebItemImage.html());
				newDiv.find('img').removeClass('lazyloaded').addClass('lazyload ignore-effect');
				frebMainImageWrap.append(newDiv);
			}
		});
		$(document).on('mouseleave', this.selectors.frebItem, function() {
			var frebItemImage = $(this).find(selector.frebItemImage);
			var imageId = frebItemImage.attr('data-image-id');
			var currentImage = frebMainImageWrap.find(selector.frebItemImage + '[data-image-id="' + imageId + '"]');
			if(currentImage.length > 0) {
				currentImage.hide();
			}
			frebMainImage.show();
		});
		BT.applyCustomColorSwatches(this.selectors.wrap);
	}
}